<template>
  <div>
    <h1 class="item-title">{{ $t('components_contract_change_payment.he_tong_xin_xi') }}</h1>
    <div class="item-title-info">
      <el-row>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_payment.he_tong_lei_xing') }}:</span>
          <span class="value">{{ getDicValue('crm_contract_type', detail.contractType) }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_payment.he_tong_bian_hao') }}:</span>
          <span class="value">{{ detail.contractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_payment.sghth') }}:</span>
          <span class="value">{{ detail.customContractNo }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_payment.jfsqdbgs') }}:</span>
          <span class="value">{{ detail.partyAName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_payment.yi_fang') }}:</span>
          <span class="value">{{ detail.customerName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_payment.shou_hou_gong_si') }}:</span>
          <span class="value">{{ detail.afterServiceName }}</span>
        </el-col>
        <el-col :span="8">
          <span class="label">{{ $t('components_contract_change_payment.xiang_mu_ming_cheng') }}:</span>
          <span class="value">{{ detail.locationName }}</span>
        </el-col>
        <el-col :span="16">
          <span class="label">{{ $t('components_contract_change_payment.shi_yong_di_dian') }}:</span>
          <span class="value">{{ detail.country || '' }}{{ detail.province || '' }}{{ detail.city || '' }}{{ detail.useAddress }}</span>
        </el-col>
      </el-row>
    </div>
    <h1 class="item-title">{{ $t('components_contract_change_payment.sbbgxx') }}</h1>
    <div class="stop-rent-tip" v-if="lastDevice.length"><i class="icon icon-tishi"></i><span>{{$t('components_contract_change_payment.ji_shen_hao')}} {{lastDevice.join('，')}} {{$t('components_contract_change_payment.yxzbzcbgzfzq')}}</span></div>
    <div style="margin-bottom: 30px">
      <custom-table ref="customTb1" v-model="selectDevice" type="checkbox" tableCode="changePayment" :data="dataList" @filter="filterChange" @sort="sortChange" :slots="['lastReceivedPeriod','startChangePeriod','newPayment', 'action']">
        <template slot="lastReceivedPeriod" slot-scope="scope">
          {{scope.row.lastReceivedPeriod || '-'}}/{{scope.row.totalTerm || '-'}}
        </template>
        <template slot="startChangePeriod" slot-scope="scope">
          <custom-select
            width="98%"
            :disabled="model.type === 'watch' || scope.row.isExists"
            v-model="scope.row.startChangePeriod"
            :filterOptions="scope.row"
            :dataFilter="startPeriodDataFilter"
          ></custom-select>
        </template>
        <template slot="newPayment" slot-scope="scope">
          <custom-select
            width="98%"
            :disabled="model.type === 'watch' || scope.row.isExists"
            v-model="scope.row.newPaymentPeriod"
            code="crm_payment_period"
            :filterOptions="scope.row"
            :dataFilter="paymentDataFilter"
          ></custom-select>
        </template>
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" :disabled="!scope.row.newPaymentPeriod || (model.row && model.row.changeState == 10)" @click="onPreview(scope.row)">
            {{ $t('components_contract_change_payment.yu_lan_zhang_dan') }}
          </el-button>
        </template>
      </custom-table>
    </div>
    <el-form :model="form" ref="form" label-width="auto" :rules="rules">
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('components_contract_change_payment.shen_qing_miao_shu')" prop="changeDesc">
            <el-input :disabled="model.type === 'watch'" type="textarea" :rows="4" :placeholder="$t('components_contract_change_payment.qtxggsbdyy')" v-model="form.changeDesc" style="width: 636px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 预览账单 -->
    <preview-bill-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false"></preview-bill-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import previewBillDialog from './children/preview_bill_dialog.vue';

export default {
  components: { previewBillDialog },
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '', // 新增时为orderId, 编辑查看时为changeId
        };
      },
    },
  },
  data() {
    return {
      dialogModel: {},
      dialogVisible: false,
      detail: {},
      dataList: [],
      lastDevice: [],
      selectDevice: [],
      form: {
        changeOrderId: '',
        orderId: '',
        changeDesc: '',
        changeOrderDevices: [],
      },
    };
  },
  mounted() {
    this.initDialog();
  },

  computed: {
    rules() {
      return {
        changeDesc: [
          { required: true, message: this.$t('Common.com_required') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ],
      };
    },
  },
  methods: {
    // 预览账单
    onPreview: function (row) {
      this.dialogModel.title = this.$t('components_contract_change_payment.yu_lan_zhang_dan');
      this.dialogModel.type = 'change_payment';

      this.dialogModel.row = Object.assign({}, this.detail, { ...row, startChangeTermNum: row.startChangePeriod });
      this.dialogVisible = true;
    },
    startPeriodDataFilter: function (list, option) {
      const arr = [];
      for (let i = option.lastReceivedPeriod + 1; i <= option.totalTerm; i++) {
        arr.push({
          name: i,
          value: i
        });
      }
      return arr;
    },
    paymentDataFilter: function (list, option) {
      return list.filter(t => `${t.value}` !== `${option.oldPaymentPeriod}`);
    },
    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        this.form.orderId = this.model.changeId;
        this.getOrderInfo();
        this.getDeviceList();
      }
      if (this.model.type === 'edit') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.getDeviceList(list);
        });
      }
      if (this.model.type === 'watch') {
        this.form.changeOrderId = this.model.changeId;
        this.getChangeDetail((list) => {
          this.dataList = list;
          this.dataList.forEach((item) => {
            item.isExists = true;
            this.$refs.customTb1.$emit('toggleRowSelection', item, true);
          });
        });
      }
    },
    // 订单信息
    getOrderInfo: function () {
      this.$getJSON(apis.ChangeOrderInfo, {
        orderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
      });
    },
    // 获取变更详情
    getChangeDetail: function (cb) {
      cb = cb || function () {};
      this.$getJSON(apis.OrderChangeInfo, {
        changeOrderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
        this.form.orderId = res.data.orderId;
        this.form.changeDesc = res.data.changeDesc;
        cb(res.data.changeDeviceInfos);
      });
    },
    // 合同设备列表
    getDeviceList: function (selectDevice) {
      this.$getJSON(apis.OrderChangeDeviceList, {
        orderId: this.form.orderId,
        showDeviceType: 0,
        showCurrentPeriod: 1,
        bizState: ['22', '29'],
      }).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.oldPaymentPeriod = item.paymentPeriod;
          item.newPaymentPeriod = '';
          item.startChangePeriod = '';
          // 预览账单用到
          item.startChangeTermNum = '';
        });
        this.dataList = list;
        // 选中行
        if (selectDevice) {
          this.dataList.forEach((item) => {
            const row = selectDevice.find(t => t.orderDeviceId === item.orderDeviceId);
            if (row) {
              item.newPaymentPeriod = `${row.newPaymentPeriod}`;
              this.$refs.customTb1.$emit('toggleRowSelection', item, true);
            }
          });
        }
        // 在原合同时（续租设备处理）
        const lastDeviceList = list.filter(t => !!t.renewalOrderDeviceId);
        if (lastDeviceList.length > 0) {
          this.lastDevice = lastDeviceList.map(f => f.bodyNum);
          this.dataList.forEach((item) => {
            item.isExists = !!item.renewalOrderDeviceId;
          });
        }
      });
    },
    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return;
        }
        if (!this.selectDevice.length) {
          this.$message.error(this.$t('components_contract_change_payment.qing_xuan_ze_she_bei'));
          return;
        }
        const hasEmpty = this.selectDevice.find(t => !t.newPaymentPeriod);
        if (hasEmpty) {
          this.$message.error(this.$t('components_contract_change_payment.qxzxdzfzq'));
          return;
        }
        // 新需求，提交前得先验证预览账单
        await this.checkPreviewBill();
        this.form.isStartApprove = approve || 0;
        this.form.changeOrderDevices = this.selectDevice;
        this.$postJSON(apis.PaymentSave, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
        });
      });
    },
    // 验证预览账单
    checkPreviewBill: async function () {
      for (let i = 0; i < this.selectDevice.length; i++) {
        this.selectDevice[i].startChangeTermNum = this.selectDevice[i].startChangePeriod;
        await this.$postJSON(apis.previewBillPaymentPeriod, this.selectDevice[i]);
      }
    },
  },
};
</script>

<style lang="scss"></style>
